import { createRequiredAndOptionalContext } from '@festina-life/ui/libs'

type EmployerAgreementIdContext = {
  employerAgreementId: string
}

const [
  useEmployerAgreementIdContext,
  useOptionalEmployerAgreementIdContext,
  Provider,
] = createRequiredAndOptionalContext<EmployerAgreementIdContext>(
  'EmployerAgreementIdContext',
)

export {
  Provider,
  useEmployerAgreementIdContext,
  useOptionalEmployerAgreementIdContext,
}
